import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './css/style.css';

import Portal from "./pages/Portal";
import Rewards from "./pages/Rewards";

function App() {

  return (
    <>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route index element={<Portal />} />
            <Route path="portal" element={<Portal />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </BrowserRouter>
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
